import service from '@/plugins/service'

const base = '/ysb/staff/'

export const searchYSBStaffs = (current, pageSize, data) => service({
  url: `${base}query`,
  method: 'POST',
  params: {
    current,
    pageSize
  },
  data
})

export const postYSBStaff = data => service({
  url: `${base}`,
  method: 'POST',
  data
})

export const putYSBStaff = data => service({
  url: `${base}`,
  method: 'PUT',
  data
})

export const deleteYSBStaff = id => service({
  url: `${base}`,
  method: 'DELETE',
  params: {
    id
  }
})